import styled, { css } from 'styled-components'
import { Modal as SemanticModal } from 'semantic-ui-react'

export const Modal = styled(SemanticModal)`
  ${({ isPage, size, filePreview, fullscreen, theme }) => css`
    &&& {
      position: absolute !important;
      margin: 40px auto auto auto !important;
      top: 0 !important;
      overflow: visible !important;
      height: auto;
      background: none;
      transition: width 0.3s ease-in-out;
      ${size === 'full' || (isPage && !size) ? 'width: 95% !important' : ''};

      ::after {
        position: absolute;
        content: '';
        height: 40px;
        width: 1px;
      }

      > .close.icon {
        font-size: 15px !important;
        font-weight: 800;
        color: #002e3e;
        top: 10px;
        right: 1rem;
        margin: 0;
        z-index: 100;

        ::before {
          color: ${theme.primaryFontColor};
        }
      }

      > .actions,
      > .content,
      > .description,
      > .header {
        background: #fff !important;
      }

      > .header {
        padding: 1em 1.5em;
        font-weight: 500 !important;
        font-size: 16px !important;
        color: #012d3e !important;
        ${filePreview ? 'display: none' : ''};
      }

      > .content {
        color: ${theme.primaryFontColor} !important;
        min-height: ${isPage ? '200px' : 'auto'};
        ${filePreview ? 'padding: 0' : ''};

        .fr-video {
          display: block;
          position: relative;
          width: 100%;
          padding-bottom: 56.25%;

          iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
          }
        }
      }

      .description {
        color: ${theme.primaryFontColor} !important;
        max-width: 100%;
      }

      > .actions {
        display: flex;
        justify-content: flex-end;
        padding: 1rem !important;
      }

      ${theme.mediaQueries.mobile} {
        ::after {
          content: none;
        }

        &&& {
          width: ${fullscreen ? '100%' : '80%'} !important;
        }
        min-height: ${fullscreen ? '100%' : 'auto'};
        height: auto;
        margin: 0 !important;
        background: #f5f5f5;
        padding: 0;
        border-top: 1px solid #dbe2ef;
        border-radius: 0;
        .content,
        .content > .description {
          min-height: ${fullscreen ? '100%' : 'auto'};
          ${filePreview ? 'padding: 0 !important' : ''};
        }

        .content > .description {
          padding: 0 !important;
        }
      }
    }
  `}
`
